import shield from "../Images/securedT.jpg";
import rocket from "../Images/fastT.jpg";
import trustbadge from "../Images/trustT.jpg";
// import shield from "../Images/shield.svg";
// import rocket from "../Images/rocket.svg";
// import trustbadge from "../Images/trust_badge.svg";
import portfolio from "../Images/coins-select.jpg";
// import transfer from "../Images/select-coin.jpg";
import confirmation from "../Images/cart-successful.jpg";

export const leverage = [
  {
    title: "Trusted",
    image: trustbadge,
    text: "We prioritize the safety of our users by integrating highly secured software that guarantees transparent, reliable and trusted exchanges.",
  },
  {
    title: "Secured Transactions",
    image: shield,
    text: "Securely sell your crypto with our safe platform that gives you absolute control over your assests with secured multi-layer protection.",
  },
  {
    title: "Fast Services",
    image: rocket,
    text: "Sell instantly with our fast and easy process that gives you instant deposit and withdrawal capabilities with 24/7 quick customer support.",
  },
];
export const processes = [
  {
    title: "Select A Coin",
    image: portfolio,
    text: "Select a coin from the list of available coins. Only the types we support are available. For ethereum, we only support erc20. ",
    // text: "Select a coin from the list of available coins. You can use Padicoins calculator to check the value your coin of choice.",
  },
  // {
  //   title: "Generate A Wallet Address",
  //   image: transfer,
  //   text: "Only your account number, mobile number and email address are needed to automatically generate a wallet address for you to send your coins to.",
  // },
  {
    title: "Make A Transfer",
    image: confirmation,
    text: "Once your transaction has been confirmed, your bank account will be credited instantly.",
  },
  {
    title: "Get Paid",
    image: confirmation,
    text: "Once your transaction has been confirmed, your bank account will be credited instantly.",
  },
];

export const frequentQuestions = [
  // {
  //   title: "What is PadiCoins?",
  //   text: "Padicoins is one of the most secured and trusted cryptocurrency exchange platform in Nigeria where people can easily trade crypto and receive direct payment into their bank accounts with zero charges .",
  // },
  {
    title: "Is PadiCoins safe?",
    text: "Yes! We use the best cutting-edge technologies to protect our website and secure the privacy and informaton of our users",
  },
  {
    title:
      "Do I need to register with my ID card and other KYC requirements before I can sell?",
    text: "No! All you need are your account number, phone number and email address only. It's that easy.",
  },
  {
    title: "How do I withdraw into my bank account?",
    text: "It is an automatic process.As soon as we receive your coin transfer, you get an instant credit alert. ",
  },
];
